import './JavaScripts/Project/globals';

import 'lazyembed2';
import 'vanilla-lazyload';
import 'jquery';

/**
 * Bootstrap
 */
// import 'bootstrap';
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/popover';

/**
 * Slick
 */
import 'slick-carousel';

/**
 * Bootstrap-Select
 */
import 'bootstrap-select';

/**
 * jQuery Libraries
 * ToDo: Replace them with imports or javascript
 */
import './JavaScripts/IePopup';
import './JavaScripts/Libraries/js-scrollspy';
import './JavaScripts/jQuery/jquery.smart-resize';
import './JavaScripts/jQuery/jquery.menu-aim';
import './JavaScripts/jQuery/jquery.bootstrap-touchspin';
import './JavaScripts/jQuery/jquery.input-placeholder-polyfill';

import './JavaScripts/jQuery/jquery.scrollTo';
import './JavaScripts/jQuery/jquery.waypoints';
import './JavaScripts/jQuery/jquery.datatables'; // datatables extension imports not working when using module imports
import './JavaScripts/jQuery/jquery.ajaxq-0.0.1';
import './JavaScripts/jQuery/jquery.equal-heights';
import './JavaScripts/jQuery/jquery.element-in-viewport';
import './JavaScripts/jQuery/jquery.article-gallery';
import './JavaScripts/jQuery/jquery.article-content-layer';
import './JavaScripts/jQuery/jquery.ajax-variants';
import './JavaScripts/jQuery/jquery.article-buy';
import './JavaScripts/jQuery/jquery.shopping-buttons';
import './JavaScripts/jQuery/jquery.prices';
import './JavaScripts/jQuery/jquery.annotations';

import './JavaScripts/Libraries/BootstrapTabcollapse';
import 'openseadragon';
import './JavaScripts/Libraries/moment.min';
import './JavaScripts/Libraries/bootstrap-datetimepicker.min';
import './JavaScripts/Libraries/jquery.mark';
import '../../../../Avency.Nwd.Products/Resources/Private/JavaScripts/Tooth';
import './JavaScripts/Libraries/videojs/video';
// import 'lodash';
import './JavaScripts/Libraries/lodash';
import './JavaScripts/Libraries/lightbox.min';
import './JavaScripts/Libraries/bootstrap-slider.min';
import 'bootbox';

// Project files
import './JavaScripts/Project/PageLoadedQueue';
import './JavaScripts/Project/Viewport';
import './JavaScripts/Project/Modal';

// Project functions
import './JavaScripts/Project/Functions/Viewport';
import './JavaScripts/Project/Functions/ListElement';
import './JavaScripts/Project/Functions/Url';
import './JavaScripts/Project/Functions/Cookies';
import './JavaScripts/Project/Functions/TouchSpin';
import './JavaScripts/Project/Functions/Popovers';
import './JavaScripts/Project/Functions/Annotations';
import './JavaScripts/Project/Functions/AjaxVariants';
import './JavaScripts/Project/Functions/ArticleContentLayer';
import './JavaScripts/Project/Functions/UpdateCartPreviewCount';
import './JavaScripts/Project/Functions/GetPrice';
import './JavaScripts/Project/Functions/RenderModal';

// Project modules
import './JavaScripts/Project/Modules/Events/Articles';
import './JavaScripts/Project/Modules/Events/SubCategories';
import './JavaScripts/Project/Modules/Carousel';
import './JavaScripts/Project/Modules/Popover';
import './JavaScripts/Project/Modules/Dropdown';
import './JavaScripts/Project/Modules/StickyHeader';
import './JavaScripts/Project/Modules/Accordion';
import './JavaScripts/Project/Modules/Select';
import './JavaScripts/Project/Modules/UserList';
import './JavaScripts/Project/Modules/QuickOrder';
import './JavaScripts/Project/Modules/ListSorting';
import './JavaScripts/Project/Modules/ResetForm';
import './JavaScripts/Project/Modules/Accessories';
import './JavaScripts/Project/Modules/Popup';
import './JavaScripts/Project/Modules/Checkout';
import './JavaScripts/Project/Modules/Category';
import './JavaScripts/Project/Modules/OrderComment';
import './JavaScripts/Project/Modules/Dashboard';
import './JavaScripts/Project/Modules/ContentPopup';
import './JavaScripts/Project/Modules/FormJsSubmit';
import './JavaScripts/Project/Modules/PasswordStrength';
import './JavaScripts/Project/Modules/ShowPassword';
import './JavaScripts/Project/Modules/StandalonePortal';
import './JavaScripts/Project/Modules/RecentlyViewed';
import './JavaScripts/Project/Modules/RecentlyViewedSidebar';


/*
 * This file contains all scripts that were declared directly in the Main.js before
 * Those functions should be seperated into own files for a better overview
 */
import './JavaScripts/ScriptCollection';

// Project Plugins

// import '../../../../Avency.Nwd.Forms/Resources/Private/JavaScripts/Shipping'; // ToDo: File is missing?
import './JavaScripts/Project/Modules/SearchFlyout';
import './JavaScripts/Project/Events';
import './JavaScripts/Project/Plugins/Debounce';
import './JavaScripts/Project/Plugins/Throttle';
import './JavaScripts/Project/Plugins/RequestArguments';
import './JavaScripts/Project/Plugins/ProductFilters';
import './JavaScripts/Project/Plugins/ProductSort';
import './JavaScripts/Project/Plugins/CategoryTree';
import './JavaScripts/Project/Plugins/MarkSearchWord';
import './JavaScripts/Project/Plugins/ScrollToAnchor';
import './JavaScripts/Project/Plugins/DateTimePicker';
import './JavaScripts/Project/Plugins/DropdownHover';
import './JavaScripts/Project/Plugins/FormScripts';
import './JavaScripts/Project/Plugins/LimitSelect';
import './JavaScripts/Project/Plugins/FixedFilters';
import './JavaScripts/Project/Plugins/UserListSelect';
import './JavaScripts/Project/Plugins/ErpShoppingBasket';
import './JavaScripts/Project/Initialize';
import './JavaScripts/Project/Plugins/InfiniteScroll';
import './JavaScripts/Project/Plugins/AjaxSubmit';
import './JavaScripts/Project/ResponsiveTableDropdown';
import './JavaScripts/Project/Plugins/CustomerConditions';
import './JavaScripts/Project/Plugins/PunchOut';
import './JavaScripts/Project/Modules/Slick';
import './JavaScripts/Project/Modules/LazyEmbed';
import './JavaScripts/Project/Modules/ProductVideo';
import './JavaScripts/Project/Plugins/CmsTooltips';
import '../Fusion/Component/Atom/MainMenu/MainMenu';
import '../Fusion/Component/Molecule/BlogPosts/BlogPosts';
import '../../../../Avency.Nwd.Search/Resources/Private/Fusion/Component/Molecule/SearchResults/SearchResults';
import '../../../../Avency.Shop.Filter/Resources/Private/Fusion/Component/Molecule/Filter/Filter';
import '../../../../Avency.Nwd.Products/Resources/Private/Fusion/Component/Molecule/ArticleHeader/ArticleHeaderRight';
import '../../../../Avency.Nwd.Products/Resources/Private/Fusion/Component/Molecule/ArticleContent/ArticleContent';
import '../../../../Avency.Nwd.Products/Resources/Private/Fusion/Component/Molecule/ArticleDiscountPromotionHeader/ArticleDiscountPromotionHeader';
import '../../../../Avency.Plandent.Events/Resources/Private/Fusion/Component/Molecule/EventList/EventList';
